import {createAsyncThunk} from '@reduxjs/toolkit'
import {AxiosResponse} from 'axios'
import instance from '@/config/axios'
import { getSubscriptions } from '@/store/subscription/action';

export const getSubscriptionDetail = createAsyncThunk('subscription/getSubscriptionDetail',
  async ({ id }: { id: string }) => {
    const response: AxiosResponse<SubscriptionDetailState> = await instance.get(`v1/subscriptions/${id}`)
    return response.data
  })

export const editSubscription = createAsyncThunk('subscription/editSubscription',
  async ({ id, data }: { id: string, data: SubscriptionDetailPayload }, {dispatch}) => {
    const response: AxiosResponse<SubscriptionDetailState> = await instance.patch(`v1/subscriptions/${id}`, data)
    dispatch(getSubscriptions({}))
    return response.data
  })
